import styled from 'styled-components';

export const GraphContainer = styled.div`
  display: block;
  & span.subtitle {
    position: relative;
    top: 1rem;
  }
  & .bottom-subtitle {
    margin-left: 8rem;
    width: 52%;
    text-align: center;
  }
  & .simulator-graph {
    height: 400px;
    width: 100%;
    & span.porcentagem-pontos {
      font-size: 3.8rem;
      position: relative;
      top: 9.375rem;
      left: 26%;
      display: block;
      height: 0rem;
    }
    & span.porcentagem-pontos-2-digit {
      left: 29.6%;
    }
    & span.porcentagem-pontos-3-digit {
      left: 25.6%;
    }
    & span.porcentagem-pontos-4-digit {
      left: 22.1%;
    }
    & span.porcentagem-pontos-5-digit {
      left: 19.6%;
    }
    & span.porcentagem-pontos-6-digit {
      font-size: 3.2rem;
      left: 19.6%;
    }
    & .recharts-legend-wrapper {
      margin-right: 0px !important;
    }
    & g.recharts-layer text {
      display: none;
    }
    & path.recharts-sector {
      stroke: var(--secondary-color-01-100);
    }
    & .hefesto-legend-graph .recharts-custom-legend ul li {
      gap: 0.75rem;
      & .dot {
        border-radius: 0%;
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
  & span.label {
    width: 9rem;
  }
`;
